// Check if Stripe is enabled via environment variable
const isStripeEnabled = process.env.REACT_APP_STRIPE_ENABLED !== 'false';

// Stripe configuration based on environment.
// Keys come ONLY from env vars (baked in at build time by CRA):
//   local .env        -> REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY
//   Heroku config var -> REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY
// No hardcoded fallbacks: a missing key disables card payment loudly instead
// of silently shipping a stale account's key.
const stripeConfig = {
  development: {
    publishableKey: process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY || null,
  },
  production: {
    publishableKey: process.env.REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY || null,
  }
};

// Determine current environment
const environment = process.env.NODE_ENV === 'production' ? 'production' : 'development';

// Export the appropriate configuration (null if Stripe is disabled)
export const STRIPE_PUBLISHABLE_KEY = isStripeEnabled ? stripeConfig[environment].publishableKey : null;
export const STRIPE_ENABLED = isStripeEnabled;

// Loud failure when the key is missing — card payment will be unavailable
if (isStripeEnabled && !STRIPE_PUBLISHABLE_KEY) {
  console.error(
    `Stripe publishable key missing for ${environment}: set ` +
    (environment === 'production'
      ? 'REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY'
      : 'REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY') +
    ' at build time. Card payment is disabled.'
  );
}

// Validation to ensure we're using the right key type (only if Stripe is enabled)
if (isStripeEnabled && STRIPE_PUBLISHABLE_KEY) {
  if (environment === 'production' && !STRIPE_PUBLISHABLE_KEY.startsWith('pk_live_')) {
    console.warn('Warning: Using test key in production environment');
  }

  if (environment === 'development' && !STRIPE_PUBLISHABLE_KEY.startsWith('pk_test_')) {
    console.warn('Warning: Using live key in development environment');
  }
}

// Log Stripe status
if (!isStripeEnabled) {
  console.log('Stripe is disabled via REACT_APP_STRIPE_ENABLED environment variable');
}

export default stripeConfig; 